import { Link } from "react-router-dom";
import { getByType, sortMovies } from "@/utils/movie";
import type { MovieItem } from "@/mocks/movies";

function UpdateList({ items }: { items: MovieItem[] }) {
  return (
    <ul className="space-y-1">
      {items.map((movie) => (
        <li key={movie.id}>
          <Link
            to={`/detail/${movie.id}`}
            className="group flex items-center gap-3 rounded-lg p-2 transition-colors hover:bg-background-200 cursor-pointer"
          >
            <div className="h-24 w-16 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={movie.poster}
                alt={movie.title}
                title={`${movie.title} 秋霞网`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-500">
                {movie.title}
              </h3>
              <p className="mt-1 truncate text-xs text-foreground-500">
                {movie.genres.slice(0, 2).join(" · ")} · {movie.region}
              </p>
              <div className="mt-2 flex items-center gap-2">
                {movie.type === "tv" ? (
                  <span className="rounded bg-secondary-700 px-1.5 py-0.5 text-[10px] text-primary-400">
                    更新至 {movie.episodes} 集
                  </span>
                ) : (
                  <span className="rounded bg-secondary-700 px-1.5 py-0.5 text-[10px] text-accent-400">
                    HD 高清
                  </span>
                )}
                <span className="text-[10px] text-foreground-400">
                  {movie.updateTime}
                </span>
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default function LatestUpdates() {
  const latestMovies = sortMovies(getByType("movie"), "time").slice(0, 6);
  const latestTv = sortMovies(getByType("tv"), "time").slice(0, 6);

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="rounded-xl border border-background-300/60 bg-background-100 p-4 md:p-5">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
            <i className="ri-film-line text-primary-500" />
            最新电影
          </h3>
          <Link
            to="/category/movie"
            className="flex items-center gap-0.5 text-xs text-foreground-500 transition-colors hover:text-primary-500 cursor-pointer"
          >
            全部电影
            <i className="ri-arrow-right-s-line" />
          </Link>
        </div>
        <UpdateList items={latestMovies} />
      </div>

      <div className="rounded-xl border border-background-300/60 bg-background-100 p-4 md:p-5">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
            <i className="ri-live-line text-primary-500" />
            最新电视剧
          </h3>
          <Link
            to="/category/tv"
            className="flex items-center gap-0.5 text-xs text-foreground-500 transition-colors hover:text-primary-500 cursor-pointer"
          >
            全部剧集
            <i className="ri-arrow-right-s-line" />
          </Link>
        </div>
        <UpdateList items={latestTv} />
      </div>
    </div>
  );
}